import * as React from "react";

export function DiscountIcon(
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement {
  return (
    <svg width="1em" height="1em" viewBox="0 0 50 50" fill="none" {...props}>
      <path
        d="M16.667 33.333l16.666-16.666M43.75 25c0 10.355-8.395 18.75-18.75 18.75S6.25 35.355 6.25 25 14.645 6.25 25 6.25 43.75 14.645 43.75 25zm-8.333 6.25a4.167 4.167 0 11-8.334 0 4.167 4.167 0 018.334 0zm-12.5-12.5a4.167 4.167 0 11-8.334 0 4.167 4.167 0 018.334 0z"
        stroke="#55BD91"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
